import React from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';

function LogoutButton() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();          // Clear local storage + context
    navigate('/login'); // Redirect to login page
  };

  return (
    <button onClick={handleLogout} style={{ marginLeft: 'auto' }}>
      Logout
    </button>
  );
}

export default LogoutButton;
